import React, { useState } from 'react';
import Textfield from 'syf-component-library/ui/atoms/Textfield';
import Textarea from 'syf-component-library/ui/atoms/Textarea';
import { ControlWrapper } from './control.styles';
const InvalidData = "Please enter information in correct format";
export const MatchFail = "MatchFail";
const TextboxControl = (props) => {
    const [value, setValue] = useState(props.value);
    const [isrequired] = useState(props.inputMetadata.required === 'true');
    const [optionalText] = useState(isrequired ? "" : " (optional)");
    const onChange = (e) => {
        const val = e.target.value;
        setValue(val);
        props.onChange({
            id: props.inputMetadata.id,
            isvalid: (!!(isrequired && val) || !isrequired),
            value: val,
        });
    };
    const onBlur = () => {
        const regexStr = props.inputMetadata.validation;
        let errText;
        if (regexStr) {
            const regex = new RegExp(regexStr);
            if (!regex.test(value)) {
                errText = props.inputMetadata.validationtext || InvalidData;
            }
        }
        if (!errText && props.matchValue && value !== props.matchValue) {
            errText = MatchFail;
        }
        if (errText) {
            props.onChange({
                id: props.inputMetadata.id,
                isvalid: false,
                value,
                error: errText,
            });
        }
    };
    const htmlProps = {
        'aria-label': props.inputMetadata.labeltext,
        tabIndex: props.tabIndex,
    };
    const textAreaProps = {
        required: isrequired,
        maxlength: props.inputMetadata.maxlength,
        onChange: onChange,
        error: props.error,
        onBlur: onBlur,
    };
    return (React.createElement(ControlWrapper, null, props.inputMetadata.multiline === 'true' ?
        React.createElement(Textarea, Object.assign({ id: `Alme-Overlay-Form-${props.inputMetadata.id}`, autoCapitalize: "none", name: props.inputMetadata.id, placeholder: props.inputMetadata.labeltext + `${optionalText}`, sizeRatio: 5, dynamicHeight: false, value: value }, htmlProps, textAreaProps))
        : React.createElement(Textfield, Object.assign({ id: `Alme-Overlay-Form-${props.inputMetadata.id}`, autoCapitalize: "none", name: props.inputMetadata.id, placeholder: props.inputMetadata.labeltext + `${optionalText}`, width: '275px', required: isrequired, type: "text", value: value, inputClassName: "iva-text-input-field", onChange: onChange, error: props.error, onBlur: onBlur, showMaskedOption: props.inputMetadata.mask === 'true' }, htmlProps))));
};
export default TextboxControl;
